import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons"

import * as style from "./carousel.module.scss"

const Carousel = ({ n, children }) => {
  const [slide, setSlide] = React.useState(0)

  return (
    <div className={`margins`}>
      <div className={style.carouselWrap}>
        <div
          className={style.leftArr}
          onClick={() => {
            if (slide > 0) {
              setSlide(slide - 1)
            } else {
              setSlide(n - 1)
            }
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div className={style.carouselContentWrap}>
          <div
            className={style.carouselStretch}
            style={{ width: `${n * 100}%`, left: `${slide * -100}%` }}
          >
            {children}
          </div>
        </div>
        <div
          className={style.rightArr}
          onClick={() => {
            if (slide < n - 1) {
              setSlide(slide + 1)
            } else {
              setSlide(0)
            }
          }}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
      <div className={style.dots}>
        {[...Array(n)].map((_, i) => {
          return (
            <div
              className={`${style.dot} ${
                slide === i ? style.active : null
              }`}
              key={i}
              onClick={() => {
                setSlide(i)
              }}
            />
          )
        })}
      </div>
    </div>
  )
}

Carousel.propTypes = {
  n: PropTypes.number,
  children: PropTypes.any,
}

Carousel.defaultProps = {
  n: `1`,
}

export default Carousel